import type { TrafficState } from '../constants';

export type AssistantObj = {
    text?: string;
    temp_message?: string;
    is_final?: boolean;
    traffic?: TrafficState;
    stage?: string;
    sql_query?: string;
    sql_queries?: Array<{ query?: string } & Record<string, any>>;
    [k: string]: any;
};

export const isAssistantObject = (content: any): content is AssistantObj =>
    content &&
    typeof content === 'object' &&
    ('text' in content || 'temp_message' in content || 'sql_query' in content || 'sql_queries' in content);

export const isAssistantFinalMessage = (content: any) => {
    if (typeof content === 'string') return true;
    if (!isAssistantObject(content)) return false;
    // Explicitly check is_final flag first
    if (content.is_final === true) return true;
    // Check for filter_confirmation stage - this is a displayable message even when is_final is false
    if (content.stage === 'filter_confirmation' && content.confirmation_required === true) return true;
    if (content.is_final === false) return false; // Explicitly NOT final
    if (content.stage === 'final_response') return true;
    // Only use text as fallback indicator if is_final is not set
    if (typeof content.text === 'string' && content.text.trim() !== '') return true;
    return false;
};

export const normalizeAssistantContent = (content: any) => {
    if (typeof content === 'string') return { text: content };
    if (!isAssistantObject(content)) return { text: JSON.stringify(content ?? '') };
    const text =
        content.text && String(content.text).trim().length > 0 ? String(content.text) : (content.temp_message ?? '');
    return { text };
};

// Re-export storage keys from constants for backward compatibility
export { STORAGE_KEYS } from '../constants';

// Deprecated: Use STORAGE_KEYS.CORRELATION instead
export const CORRELATION_KEY = (cid: string) => `correlation:${cid}`;
// Deprecated: Use STORAGE_KEYS.USER_MESSAGE instead
export const USER_MESSAGE_KEY = (cid: string) => `userMessage:${cid}`;
